<template>
  <div class="bg-dark-920 text-dark-50">
    <div class="min-h-svh">
      <div class="relative pt-4">
        <img :src="bannerGradientDark" class="absolute top-0 left-0 w-full h-full opacity-80 hidden dark:block pointer-events-none" />

        <div class="max-w-wrapper flex items-center mx-auto px-3 relative">
          <NuxtLink :to="{ name: 'dashboard' }" class="flex items-center space-x-1.5 shrink-0">
            <div>
              <img :src="logoVibesDark" class="h-6">
              <p class="uppercase text-right text-3xs font-black text-white">Backstage</p>
            </div>

            <div class="text-3xs font-black text-white">BETA</div>

            <!-- <img src="assets/img/flags/lgbtqia_animated_xl.png" class="h-9 hidden sm:block" /> -->
          </NuxtLink>

          <div class="grow" />

          <div class="relative">
            <div class="p-2 space-x-3 bg-dark-700 rounded-xl flex items-center w-48 cursor-pointer" @click="() => isMenu = !isMenu" ref="$menu">
              <div class="shrink-0 relative">
                <div class="size-8 rounded-lg bg-dark-900 bg-cover" :style="{ backgroundImage: `url(${currentOrganization?.logo?.getSize('s')})` }" />

                <IconBase name="cute/verified-gradient" class="absolute -bottom-1 -right-1" :width="18" v-if="currentOrganization?.isCertified" />
                <!-- <UserPicture :user="currentUser" size="3xs" class="!absolute bottom-0 -right-1" /> -->
              </div>
              <div class="grow">
                <p class="font-medium line-clamp-1 break-all">
                  {{ currentOrganization?.name ?? 'Choisir une organisation' }}
                </p>
              </div>
              <IconBase name="cute/angle-right" class="rotate-90" />
            </div>

            <div class="absolute right-0 -bottom-1 translate-y-full z-[100] bg-dark-700 rounded-xl w-72 overflow-hidden shadow-lg px-3" v-if="isMenu">
              <NuxtLink :href="useRuntimeConfig().public.APP_URL" target="_blank" class="py-4 space-x-3 flex items-center border-t border-dark-600 cursor-pointer first:border-transparent">
                <div class="grow">
                  <p class="font-medium line-clamp-1 break-all">
                    Aller sur Vibes
                  </p>
                </div>
                <IconBase name="cute/external" :width="18" />
              </NuxtLink>
              
              <div class="border-t pt-4 border-dark-600">
                <p class="font-medium text-2xs leading-tight">Changer d'organisation</p>
                <div class="-space-y-5 -mt-2">
                  <div class="py-4 space-x-3 flex items-center cursor-pointer" @click="async () => { await organizationStore.selectOrganization(organization._id); router.push({ name: 'dashboard' }); isMenu = false }" v-for="organization in organizations">
                    <div class="shrink-0 relative">
                      <div class="size-8 rounded-lg bg-dark-900 bg-cover" :style="{ backgroundImage: `url(${organization.logo?.getSize('s')})` }" />

                      <IconBase name="cute/verified-gradient" class="absolute -bottom-1 -right-1" :width="16" v-if="organization.isCertified" />
                    </div>

                    <div class="grow">
                      <p class="font-medium line-clamp-1 break-all">
                        {{ organization.name }}
                      </p>
                    </div>
                    <IconBase name="cute/check" :width="16" v-if="organization._id === currentOrganization?._id" />
                  </div>
                  <NuxtLink :to="{ name: 'auth-register' }" class="py-3 space-x-3 flex items-center cursor-pointer">
                    <div class="size-8 rounded-lg bg-dark-900 shrink-0 flex items-center justify-center">
                      <IconBase name="cute/plus" :width="14" />
                    </div>
                    <div class="grow">
                      <p class="font-medium line-clamp-1 break-all">
                        Créer une organisation...
                      </p>
                    </div>
                  </NuxtLink>
                </div>
              </div>

              <NuxtLink :to="{ name: 'dashboard-settings' }" class="py-4 space-x-3 flex items-center border-t border-dark-600 cursor-pointer">
                <div class="grow">
                  <p class="font-medium line-clamp-1 break-all">
                    Paramètres
                  </p>
                </div>
                <IconBase name="cute/cog" :width="18" />
              </NuxtLink>

              <NuxtLink :to="{ name: 'auth-logout' }" class="py-4 space-x-3 flex items-center border-t border-dark-600 cursor-pointer">
                <UserPicture :user="currentUser" size="xs" is-hide-badges class="shrink-0 -my-1 -mr-1" />
                <div class="grow">
                  <p class="font-medium line-clamp-1 break-all">
                    Se déconnecter
                  </p>
                </div>
                <IconBase name="cute/door-exit" :width="18" />
              </NuxtLink>
            </div>
          </div>
        </div>

        <div class="max-w-wrapper px-3 mx-auto mt-4">
          <NavTabs :items="nav" v-model="navCurrent" color="white" />
        </div>
      </div>

      <NuxtLink class="block bg-[#1f1a29] text-[#ebe1ff]" :to="{ name: 'dashboard-subscribe' }" v-if="!currentOrganization?.isPro && route.name !== 'dashboard-subscribe'">
        <div class="max-w-wrapper px-3 py-4 mx-auto flex items-center space-x-2">
          <IconBase name="cute/verified-gradient" class="shrink-0 " :width="24" />
          <div class="grow font-bold">
            Deviens pro pour débloquer toutes les fonctionnalités du Backstage
          </div>
          <IconBase name="cute/arrow-left" class="shrink-0 rotate-180" />
        </div>
      </NuxtLink>

      <div>
        <slot />
      </div>
    </div>

    <footer class="bg-dark-950">
      <div class="max-w-wrapper px-3 py-10 mx-auto">
        <img src="assets/img/logo/backstage-square.png" class="size-16 mb-3 rounded-xl shrink-0" />

        <div class="p-4 bg-royal-900/50 rounded-xl my-2">
          <p class="font-bold text-md">Un soucis ? Une question ?</p>
          <ButtonLink href="https://help.vibes.lgbt/fr/collections/13970473-qu-est-ce-que-backstage" target="blank">Consulter le Centre d'Aide</ButtonLink>
        </div>

        <div class="space-y-1">
          <div>Une question commerciale ? <ButtonLink href="mailto:pros@vibes.lgbt">pros@vibes.lgbt</ButtonLink></div>
          <div>Un problème technique ? <ButtonLink href="mailto:hey@vibes.lgbt">hey@vibes.lgbt</ButtonLink></div>
        </div>
      </div>
    </footer>

    <DialogPopin />
    <ToasterBase />
  </div>
</template>

<script lang="ts" setup>
import logoVibesDark from '@/assets/img/logo/logo-white.png'
import UserStore from '@/store/user'
import OrganizationStore from '@/store/organization'
import bannerGradientDark from '@/assets/img/gradients/hard/gradient-6.jpg'
import bannerGradientPro from '@/assets/img/gradients/hard/gradient-9.jpg'

const organizationStore = OrganizationStore()
const { currentOrganization } = storeToRefs(organizationStore)
const userStore = UserStore()
const { currentUser } = storeToRefs(userStore)

const route = useRoute()
const router = useRouter()

const isMenu = ref(false)
const organizations = computed(() => organizationStore.getItems(currentUser.value?.organizations ?? []))

const $menu = ref()
onClickOutside($menu, () => {
  isMenu.value = false
})

const navCurrent = ref('dashboard')

const nav = computed(() => {
  return [
    {
      label: 'Dashboard',
      value: 'dashboard',
      icon: 'cute/home',
      to: { name: 'dashboard' }
    },
    {
      label: 'Événements',
      value: 'events',
      icon: 'cute/calendar',
      to: { name: 'dashboard-events' }
    },
    {
      label: `Page publique`,
      value: 'organization',
      icon: currentOrganization.value?.status === 'published' ? 'cute/organization' : 'cute/warning',
      to: { name: 'dashboard-organization' }
    },
    {
      label: `Lieux`,
      value: 'olaces',
      icon: 'cute/map-marker',
      to: { name: 'dashboard-places' }
    }
  ]
})

onMounted(async () => {
  setTimeout(() => document.body.classList.add('dark'))
  await organizationStore.initOrganization()
})

</script>